import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class ConsumableItemAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      errors: {},
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      loading: true,
      consumableItemData: props.location?.state?.data,
      color: "",
    };
  }

  componentDidMount() {
    const { consumableItemData } = this.state || {};
    if (consumableItemData) {
      this.setState({
        name: consumableItemData.name,
      })
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    } else {
      setTimeout(() => {
        this.setState({ loading: false, });
      }, 500);
    }
  }


  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({ [name]: value, errors });
  };

  validateForm = () => {
    const errors = {};
    const name = this.state.name.trim();

    if (!name) {
      errors.name = "Name is required";
    }
    //  else if (!/^[A-Za-z0-9\s]+$/.test(name)) {
    //   errors.name = "Name must contain only letters, numbers, and spaces";
    // } 
    else if (name.length < 3) {
      errors.name = "Name must be at least 3 characters";
    } else if (name.length > 30) {
      errors.name = "Name must not exceed 30 characters";
    }

    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({ loading: true });
    const { consumableItemData } = this.state || {};
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        name: this.state.name,
      };

      let consumableItemStatusResponse;
      if (consumableItemData && consumableItemData.citemid) {
        consumableItemStatusResponse = await axios.put(`/consumableItems/${consumableItemData.citemid}`, payload, { headers });
      } else {
        consumableItemStatusResponse = await axios.post('/consumableItems', payload, { headers });
      }
      this.setState({
        name: "",
        hsnCode: "",
        errors: {},
        showToast: true,
        toastMessage: consumableItemStatusResponse.data.message ? consumableItemStatusResponse.data.message : "Consumable Item  added successfully!",
        toastVariant: "success",
        color: 'green',

      }, () => {
        setTimeout(() => {
          this.props.history.push('/ConsumableItemList');
          this.setState({ loading: false });
        }, 600);

      });
      // await axios.post("/consumableItems", payload, { headers });

    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error adding consumable item",
        toastVariant: "danger",
        color: 'red',
        loading: false,
      });
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/ConsumableItemList");
      this.setState({ loading: false });
    }, 500);
  }
  render() {
    return (
      <div className="pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <>
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <strong>{this.state.consumableItemData?.citemid ? "Update Consumable Item" : ' Add Consumable Item'}</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={4}>
                      <Form.Group controlId="formName">
                        <Form.Label className="required">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter consumable item name"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className='add-cancel-btn '>
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                      {this.state.consumableItemData?.citemid ? "Update" : "Add"}
                    </Button>
                    <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel " onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </>
        </CommonLoader>
      </div>
    );
  }
}
